import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import * as CommentsStore from '../../../../store/comments';
import * as ProjectsStore from '../../../../store/projects';
import * as CommonValuesStore from '../../../../store/common-values';
import { bindActionCreators } from 'redux';
import AssessmentDetails from './AssessmentDetails';
import { UserState } from 'redux-oidc';
import { match } from 'react-router';
import Loading from '../../../application/Loading';
import { ConnectedRouterProps } from 'connected-react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import GoBackContainer from './../../../application/GoBackContainer';
import {CertificationStatus, ProjectStatus} from '../../../../store/projects/commonTypes';
import Audits from './Audits';
import Comments from '../../../comments/Comments';
import AssessmentDocuments from "./AssessmentDocuments";
import {Runtime} from "inspector";
import * as RuntimeStore from "../../../../store/runtime";
import ProjectStepper from "../../../project/forms/view/ProjectStepper";
import AssessmentStepper from "./AssessmentStepper";

// At runtime, Redux will merge together...
type AssessmentViewFormProps =
    ProjectsStore.ProjectsState
    & typeof ProjectsStore.actionCreators
    & { comments: CommentsStore.CommentsState }
    & typeof CommentsStore.actionCreators
    & CommonValuesStore.CommmonValuesState
    & typeof CommonValuesStore.actionCreators
    & typeof RuntimeStore.actionCreators
    & UserState
    & ConnectedRouterProps
    & { match: match<{ pid: string, aid: string }> };

class AssesssmentViewFormContainer extends React.PureComponent<AssessmentViewFormProps> {
    certificationId: string = '';

    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.certificationId = this.props.match.params.aid;
        this.props.requestCertification(this.certificationId);
        this.props.requestCertificationAudits(this.certificationId);
        this.props.requestCertificationComments(this.certificationId);
    }

    public render() {
        return (
            <React.Fragment>
                <GoBackContainer title="QA-Prosess" onGoBack={() => this.props.history.goBack()}>
                    {this.props.isLoading ? (
                        <Loading />
                    ) : (this.props.certification ? (
                        <div>
                            {this.props.certification.certificationStatus != CertificationStatus.cancelled && (
                                <AssessmentStepper certification={this.props.certification} className="mb-3 mt-3" />
                            )}
                            <div className="row">
                                <div className="col-sm-6 mb-4">
                                    <AssessmentDetails certification={this.props.certification} user={this.props.user!} showError={error => this.props.showNotification(error, "error")} />
                                </div>
                                <div className="col-sm-6 mb-4">
                                    <div className="mb-3">
                                        {this.props.isAuditsLoading ? (
                                            <Loading />
                                        ) : (
                                                <Audits
                                                    allowToAddReport={
                                                        this.props.audits.filter(_ =>
                                                        _.statusId == 1 ||
                                                        _.statusId == 283210000 ||
                                                        _.statusId == 283210003).length == 0 &&
                                                        this.props.certification.statusId == 1
                                                    }
                                                    user={this.props.user!}
                                                    showError={error => this.props.showNotification(error, "error")}
                                                    audits={this.props.audits}
                                                    onOpenAudit={(auditId: string) => this.props.history.push(`/projects/details/${this.props.match.params.pid}/assessment/${this.props.match.params.aid}/audits/${auditId}`)}
                                                    onOpenNewUploadForm={() => this.props.history.push(`/projects/details/${this.props.match.params.pid}/assessment/${this.props.match.params.aid}/report/new`)}
                                                />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            <AssessmentDocuments openLink={() => {this.props.openCertificationDocuments(this.certificationId)}} isLoading={this.props.documentsLinkLoading} expiratioDate={this.props.documentsLinkExpiration} documentsLink={this.props.documentsLink} />
                            <div>
                                <div>
                                    <h4>Meldinger</h4>
                                    <Comments comments={this.props.comments.comments} isLoading={this.props.comments.isLoading} onPostComment={(comment: CommentsStore.Comment) => this.props.addCertificationComment(comment, this.props.certification?.id ?? '')} />
                                </div>
                            </div>
                        </div>
                    ) : (
                            <span></span>
                        )
                        )}
                </GoBackContainer>
            </React.Fragment >
        );
    }
}

export default connect(
    (state: RootState) => {
        const { projects, commonValues, oidc, comments , runtime} = state;
        return {
            ...projects,
            ...commonValues,
            ...oidc,
            ...runtime,
            comments: { ...comments }
        };
    },
    (dispatch) => {
        return {
            ...bindActionCreators(
                Object.assign(
                    {},
                    ProjectsStore.actionCreators,
                    CommentsStore.actionCreators,
                    CommonValuesStore.actionCreators,
                    RuntimeStore.actionCreators
                ), dispatch)
        };
    }
)(AssesssmentViewFormContainer as any); // eslint-disable-line @typescript-eslint/no-explicit-any
